import React, { useEffect, useRef, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { authHeaders } from "../utils/authHeaders";

export const SURVEY_ROLE_OPTIONS = [
  { value: "user", label: "User" },
  { value: "mitra sahabat kakao", label: "Mitra Sahabat Kakao" },
  { value: "sahabat kakao", label: "Sahabat Kakao" },
  { value: "field team", label: "Field Team" },
  { value: "management", label: "Management" },
  { value: "admin", label: "Admin" },
];

export default function SurveyAccessDialog({ survey, user, api, onClose, onSaved }) {
  const [mode, setMode] = useState(survey.allowed_roles == null ? "public" : "roles");
  const [roles, setRoles] = useState(survey.allowed_roles || []);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const dialogRef = useRef(null);

  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialogRef.current?.querySelector("button")?.focus();
    return () => {
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    };
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (mode === "roles" && !roles.length) {
      setError("Pilih minimal satu role yang dapat mengakses survey.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      const response = await fetch(`${api}/surveys/${survey.id}/access`, {
        method: "PUT",
        headers: authHeaders(user, { "Content-Type": "application/json", Accept: "application/json" }),
        credentials: "include",
        body: JSON.stringify({ allowed_roles: mode === "public" ? null : roles }),
      });
      const data = await response.json();
      if (!response.ok || !data.success) throw new Error(data.message || "Gagal menyimpan akses survey.");
      onSaved(data.allowed_roles);
    } catch (err) {
      setError(err.message || "Gagal menyimpan akses survey.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="survey-access-overlay" onClick={() => { if (!saving) onClose(); }}>
      <section ref={dialogRef} className="survey-access-dialog" role="dialog" aria-modal="true" aria-labelledby="survey-access-title" onClick={(event) => event.stopPropagation()} onKeyDown={(event) => {
        if (event.key === "Escape" && !saving) onClose();
        if (event.key !== "Tab") return;
        const elements = dialogRef.current.querySelectorAll("button:not(:disabled), input:not(:disabled)");
        const first = elements[0];
        const last = elements[elements.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }}>
        <header>
          <div><h2 id="survey-access-title">Akses Survey</h2><p>{survey.title}</p></div>
          <button type="button" onClick={onClose} disabled={saving} aria-label="Tutup pengaturan akses" title="Tutup"><FaTimes aria-hidden="true" /></button>
        </header>
        <form onSubmit={submit}>
          <fieldset disabled={saving}>
            <legend>Siapa yang dapat mengakses?</legend>
            <label className="survey-access-choice"><input type="radio" name="survey-access-mode" value="public" checked={mode === "public"} onChange={() => setMode("public")} /><span>Semua orang, termasuk pengunjung tanpa login</span></label>
            <label className="survey-access-choice"><input type="radio" name="survey-access-mode" value="roles" checked={mode === "roles"} onChange={() => setMode("roles")} /><span>Role tertentu</span></label>
          </fieldset>
          {mode === "roles" && <fieldset className="survey-access-roles" disabled={saving}>
            <legend>Role yang diizinkan</legend>
            {SURVEY_ROLE_OPTIONS.map((option) => <label key={option.value} className="survey-access-choice"><input type="checkbox" checked={roles.includes(option.value)} onChange={(event) => setRoles((current) => event.target.checked ? [...current, option.value] : current.filter((value) => value !== option.value))} /><span>{option.label}</span></label>)}
          </fieldset>}
          <p className="survey-access-note">Admin tetap dapat mengelola dan mengakses semua survey. Perubahan akses langsung berlaku pada Lapor Yuk dan tautan survey.</p>
          {error && <p className="survey-access-error" role="alert">{error}</p>}
          <footer><button type="button" onClick={onClose} disabled={saving}>Batal</button><button type="submit" disabled={saving}>{saving ? "Menyimpan..." : "Simpan Akses"}</button></footer>
        </form>
      </section>
    </div>
  );
}
